import { render, staticRenderFns } from "./OilArea.vue?vue&type=template&id=42a28712&scoped=true&"
import script from "./OilArea.vue?vue&type=script&lang=js&"
export * from "./OilArea.vue?vue&type=script&lang=js&"
import style0 from "./OilArea.vue?vue&type=style&index=0&id=42a28712&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a28712",
  null
  
)

export default component.exports